import { FETCH_PORTAL_TRADITIONAL_DELIVERY_ADDRESSES } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_PORTAL_TRADITIONAL_DELIVERY_ADDRESSES:
      return action.payload
    default:
      return state
  }
}
